import React from 'react';
import PropTypes from 'prop-types';
import ChatView from '../../chatView/components/ChatView';
import { SESSION_TYPES } from '../../chatView/constants';
import SubPageHeader from '../../components/molecules/SubPageHeader';
import { buildDrilldownUserMessage } from '../consts';
import css from './DrilldownView.css';

const DrilldownView = ({ payload, onBack }) => (
    <div className={css.drilldownView}>
        <SubPageHeader
            onGoBack={onBack}
            labelTranslationKey="STATIC.BUTTONS.DRILLDOWN"
        />
        <ChatView
            readOnly
            initialPayload={{
                content: buildDrilldownUserMessage(payload),
                body: payload,
            }}
            runPath="drilldown"
            sessionType={SESSION_TYPES.DRILLDOWN}
        />
    </div>
);

DrilldownView.propTypes = {
    payload: PropTypes.shape({
        metric: PropTypes.shape({
            api_name: PropTypes.string.isRequired,
            display_name: PropTypes.string.isRequired,
        }).isRequired,
        filters: PropTypes.arrayOf(PropTypes.shape({
            dimension: PropTypes.string.isRequired,
            operator: PropTypes.string,
            values: PropTypes.arrayOf(PropTypes.string).isRequired,
        })).isRequired,
        change: PropTypes.string.isRequired,
        start_date: PropTypes.string.isRequired,
        end_date: PropTypes.string.isRequired,
        previous_period_start: PropTypes.string.isRequired,
        previous_period_end: PropTypes.string.isRequired,
    }).isRequired,
    onBack: PropTypes.func.isRequired,
};

export default DrilldownView;
